var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusInCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.225C12.5385 6.225 12.975 6.66152 12.975 7.2V11.025H16.8C17.3385 11.025 17.775 11.4615 17.775 12C17.775 12.5385 17.3385 12.975 16.8 12.975H12.975V16.8C12.975 17.3385 12.5385 17.775 12 17.775C11.4615 17.775 11.025 17.3385 11.025 16.8V12.975H7.2C6.66152 12.975 6.225 12.5385 6.225 12C6.225 11.4615 6.66152 11.025 7.2 11.025H11.025V7.2C11.025 6.66152 11.4615 6.225 12 6.225ZM12 22.05C17.5505 22.05 22.05 17.5505 22.05 12C22.05 6.44954 17.5505 1.95 12 1.95C6.44954 1.95 1.95 6.44954 1.95 12C1.95 17.5505 6.44954 22.05 12 22.05ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#B8BDBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusInCircle);
export default __webpack_public_path__ + "static/media/PlusInCircle.b54e41602da105946124a7f98f371ce4.svg";
export { ForwardRef as ReactComponent };